import { render, staticRenderFns } from "./SelectReportDialog.vue?vue&type=template&id=2d138173&"
import script from "./SelectReportDialog.vue?vue&type=script&lang=js&"
export * from "./SelectReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectReportDialog.vue?vue&type=style&index=0&id=2d138173&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QBtnToggle,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle,QBtn})
